import { isAuthPagePath } from './authPagePaths.js';

const sidebarHiddenPathPatterns = [
  /^\/campaign-hub$/,
  /^\/campaigns\/\d+/,
  /\/user\/campaigns\//,
  /^\/campaigns\/learn(-more)?$/,
  /^\/user\/chats$/,
  /^\/about(\/.*)?$/,
  /^\/community-guidelines$/,
  /^\/jobs$/,
  /^\/download-app$/,
];

export function isSidebarHiddenPath(pathname) {
  return sidebarHiddenPathPatterns.some((pattern) => pattern.test(pathname)) || isAuthPagePath(pathname);
}

export function shouldShowSidebarMenu(pathname) {
  return !isSidebarHiddenPath(pathname);
}
